import React from 'react';
import ListingPage from './listing-page';

export default function render(entry) {
    return <ListingPage entry={entry} />;
}
